import React, { useEffect, useState } from 'react'
import { streamUrl } from '../api/client'
import LazyWaveform from './LazyWaveform'

/** Vorher = Original (amber), Nachher = Master (teal) – jeweils eigenständig abspielbar. */
const ORIGINAL_WAVE = '#f59e0b'
const ORIGINAL_PROGRESS = '#fbbf24'
const MASTER_WAVE = '#00d4aa'
const MASTER_PROGRESS = '#5eead4'

/**
 * A/B-Player: Vorher/Nachher.
 * Original lädt als kompakte Preview-MP3 (nicht volle WAV) – deutlich schneller.
 * Waveforms starten erst, wenn der Block sichtbar ist; Nachher zuerst.
 */
export default function ABPlayer({ trackId, hasOriginal, hasMaster, preferMp3 = true }) {
  const [loadOriginal, setLoadOriginal] = useState(false)

  // Nachher (Master-MP3) zuerst; Original-Preview kurz danach (weniger parallele Last)
  useEffect(() => {
    if (!hasOriginal) return
    const t = setTimeout(() => setLoadOriginal(true), hasMaster ? 120 : 0)
    return () => clearTimeout(t)
  }, [hasOriginal, hasMaster, trackId])

  const originalUrl =
    trackId && hasOriginal && loadOriginal ? streamUrl(trackId, 'original_preview') : null
  const masterUrl = trackId && hasMaster ? streamUrl(trackId, preferMp3 ? 'mp3' : 'wav') : null

  if (hasOriginal && hasMaster) {
    return (
      <div className="space-y-6">
        <div className="rounded-xl border border-white/10 bg-white/5 p-4">
          <p className="mb-3 text-sm font-medium text-[#99f6e4]">Nachher (Master)</p>
          <LazyWaveform
            audioUrl={masterUrl}
            height={80}
            showControls
            controlsPosition="bottom"
            waveColor={MASTER_WAVE}
            progressColor={MASTER_PROGRESS}
            className="w-full"
          />
        </div>
        <div className="rounded-xl border border-white/10 bg-white/5 p-4">
          <p className="mb-1 text-sm font-medium text-amber-200/90">Vorher (Original)</p>
          <p className="mb-3 text-xs text-white/40">Vorschau-Qualität (schnell geladen) – Download bleibt unverändert.</p>
          <LazyWaveform
            audioUrl={originalUrl}
            height={80}
            showControls
            controlsPosition="bottom"
            waveColor={ORIGINAL_WAVE}
            progressColor={ORIGINAL_PROGRESS}
            className="w-full"
          />
        </div>
      </div>
    )
  }

  const audioUrl = hasMaster ? masterUrl : hasOriginal ? originalUrl : null
  const waveColor = hasMaster ? MASTER_WAVE : ORIGINAL_WAVE
  const progressColor = hasMaster ? MASTER_PROGRESS : ORIGINAL_PROGRESS

  return (
    <div className="space-y-4">
      {audioUrl || (hasOriginal && !loadOriginal) ? (
        <div className="rounded-xl border border-white/10 bg-white/5 p-4">
          <LazyWaveform
            audioUrl={audioUrl}
            height={140}
            showControls
            controlsPosition="left"
            waveColor={waveColor}
            progressColor={progressColor}
          />
        </div>
      ) : (
        <p className="rounded-xl border border-white/10 bg-white/5 px-4 py-8 text-center text-sm text-white/50">
          Kein Original oder Master zum Abspielen verfügbar.
        </p>
      )}
    </div>
  )
}
